export const loginConstants = {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_ERROR: 'LOGIN_ERROR',
    USER_LOADED: 'USER_LOADED',
    LOGOUT: 'LOGOUT'
  };
  